<template>
    <div class="formulate-option-selector">
        <v-select ref="select" :class="`formulate-input-element formulate-input-element--${context.type}`" :data-type="context.type" :modelValue="context._value" @update:modelValue="handleInput" :reduce="(x) => x.value" v-bind="context.attrs" :options="selectOptions" :placeholder="context.attrs?.placeholder || '- Selecteer -'" label="label" @close="onClose" @open="onOpen">
            <template #selected-option-container>
                <span class="noRender"></span>
            </template>

            <slot name="optionLabel"> </slot>

            <template #option="option">
                <div class="formulate-option-selector__option">
                    <span class="option-label">
                        <span class="projectStatus">
                            <span class="projectStatus__bullet" :style="`background-color: ${colorFor(option)};`"></span>
                            <span class="projectStatus__title">{{ option.label }}</span>
                        </span>
                    </span>
                    <span class="icon icon--check--filled--inverted icon--shakespeare option-check"></span>
                </div>
            </template>

            <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" :placeholder="attributes.placeholder || '- Selecteer -'" />
            </template>
        </v-select>
        <div class="formulate-option-selector__options" v-if="selectedOptions.length">
            <div @click="onOptionClick(option)" v-for="option in selectedOptions" :key="option.id || option.value" class="button--option button">
                <span class="icon icon--cross icon--dark">remove</span>
                <span class="projectStatus">
                    <span class="projectStatus__bullet" :style="`background-color: ${colorFor(option)};`"></span>
                    <span class="projectStatus__title">{{ option.label }}</span>
                </span>
            </div>
        </div>
    </div>
</template>

<script src="./FormulateStatusSelector.js"></script>
